import type {
    StepperSummaryTextConstantType,
    StepperSummaryTexts
} from "./type";
import {
    formatNumber
} from "../../../../helpers/locale";

export const getStepperSummaryTexts = ({
    activeLocale,
    activeIndex,
    localize,
    steps
}: StepperSummaryTextConstantType): StepperSummaryTexts => {
    const currentIndex = Math.min(Math.max(activeIndex, 0), steps.length - 1);

    const current = steps[currentIndex];

    const next = steps[currentIndex + 1];

    const errorCount = steps.filter((item) => item.status === "error").length;

    const stepOf = localize("stepper-step-of", [
        formatNumber({
            value: currentIndex + 1,
            locale: activeLocale
        }),
        formatNumber({
            locale: activeLocale,
            value: steps.length
        })
    ]);

    const errorText = errorCount === 1 ? localize("stepper-error-one") : localize("stepper-error-many", [
        formatNumber({
            locale: activeLocale,
            value: errorCount
        })
    ]);

    const title = current?.step.title ?? "";

    return {
        valueText: next ? localize("stepper-next-step", [
            next.step.title
        ]) : undefined,
        errorText: errorCount ? errorText : undefined,
        accessibleText: [
            `${stepOf}: ${title}`,
            errorCount ? errorText : undefined
        ].filter(Boolean).join(", "),
        errorCount,
        stepOf,
        title
    };
};
